import React, { useState, useEffect } from 'react';
import { Currency, CurrencyCreate } from '../types/costwand.d';
import { Input } from './ui/input.tsx';
import { Button } from './ui/button.tsx';
import { Label } from '@radix-ui/react-label'; // Using Radix Label for accessibility
import { Spinner } from './ui/spinner.tsx'; // Import Spinner

interface CurrencyFormProps {
  initialData?: Currency | null;
  onSubmit: (data: CurrencyCreate) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  // error?: string | null; // Removed error prop
}

const CurrencyForm: React.FC<CurrencyFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  isSubmitting = false,
  // error, // Removed error from destructuring
}) => {
  const [formData, setFormData] = useState<CurrencyCreate>({
    description: '',
    exchange_rate: '',
    show_on_print: true, // Default value
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        description: initialData.description,
        exchange_rate: initialData.exchange_rate,
        show_on_print: initialData.show_on_print,
      });
    } else {
      setFormData({ description: '', exchange_rate: '', show_on_print: true });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* {error && <p className="text-destructive text-sm">{error}</p>} */} {/* Removed local error display */}
      <div>
        <Label htmlFor="description" className="block text-sm font-medium text-foreground mb-1">Name</Label>
        <Input
          id="description"
          type="text"
          required
          value={formData.description}
          onChange={handleChange}
        />
      </div>
      <div>
        <Label htmlFor="exchange_rate" className="block text-sm font-medium text-foreground mb-1">Exchange Rate</Label>
        <Input
          id="exchange_rate"
          type="text"
          required
          value={formData.exchange_rate}
          onChange={handleChange}
        />
      </div>
      <div className="flex justify-end gap-2">
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? <span className="flex items-center gap-2"><Spinner size="sm" /> Saving...</span> : 'Save'}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default CurrencyForm;